import React from "react";
import { Alert } from "antd";

const UnhandledType = () => {
  return <Alert message="Error: Unhandled Field Type" type="error" showIcon />;
};
export default UnhandledType;
